import i18next from 'i18next';
import { CheckIcon } from '@heroicons/react/24/outline';

const ProductAttributesSelector = ({ sizes = [], colors = [], selectedSizes = [], selectedColors = [], onSizesChange, onColorsChange }) => {
  const handleSizeToggle = (sizeId, sizeName) => {
    const isSelected = selectedSizes.some(s => s.value === sizeId);
    if (isSelected) {
      onSizesChange(selectedSizes.filter(s => s.value !== sizeId));
    } else {
      onSizesChange([...selectedSizes, { value: sizeId, label: sizeName }]);
    }
  };

  const handleColorToggle = (colorId, colorName) => {
    const isSelected = selectedColors.some(c => c.value === colorId);
    if (isSelected) {
      onColorsChange(selectedColors.filter(c => c.value !== colorId));
    } else {
      onColorsChange([...selectedColors, { value: colorId, label: colorName }]);
    }
  };

  const handleSelectAllSizes = () => {
    if (selectedSizes.length === sizes.length) {
      onSizesChange([]);
    } else {
      onSizesChange(sizes.map(size => ({ value: size.id, label: size.name })));
    }
  };

  const handleSelectAllColors = () => {
    if (selectedColors.length === colors.length) {
      onColorsChange([]);
    } else {
      onColorsChange(colors.map(color => ({
        value: color.id,
        label: color.name[i18next.language]
      })));
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg p-4 border border-gray-300">
        <div className="flex justify-between items-center mb-4">
          <label className="text-sm font-medium text-gray-700">Sizes</label>
          <button type="button" onClick={handleSelectAllSizes} className="text-sm text-gray-600 hover:text-gray-900">
            {selectedSizes.length === sizes.length ? "Deselect All" : "Select All"}
          </button>
        </div>

        <div className="flex flex-wrap gap-2">
          {sizes.map((size) => {
            const isSelected = selectedSizes.some((s) => s.value === size.id);
            return (
              <button key={size.id} type="button" onClick={() => handleSizeToggle(size.id, size.name)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors relative
                  ${isSelected ? "bg-black text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}>
                <span className="flex items-center gap-2">
                  {size.name}
                  {isSelected && <CheckIcon className="size-4" />}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-2 text-sm text-gray-500">
          {selectedSizes.length} selected from {sizes.length}
        </div>
      </div>

      <div className="bg-white rounded-lg p-4 border border-gray-300">
        <div className="flex justify-between items-center mb-4">
          <label className="text-sm font-medium text-gray-700">Colors</label>
          <button type="button" onClick={handleSelectAllColors} className="text-sm text-gray-600 hover:text-gray-900">
            {selectedColors.length === colors.length ? "Deselect All" : "Select All"}
          </button>
        </div>

        <div className="flex flex-wrap gap-3">
          {colors.map((color) => {
            const isSelected = selectedColors.some((c) => c.value === color.id);
            return (
              <button key={color.id} type="button" onClick={() => handleColorToggle(color.id, color.name[i18next.language])}
                className={`group relative p-1 rounded-lg transition-transform hover:scale-110
                  ${isSelected ? "ring-2 ring-black" : "ring-1 ring-gray-200"}`}>
                <div className="w-8 h-8 rounded relative" style={{ backgroundColor: color.hex }}>
                  {isSelected && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded">
                      <CheckIcon className="size-5 text-white" />
                    </div>
                  )}
                </div>
                <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap">
                  {color.name[i18next.language]}
                </div>
              </button>
            );
          })}
        </div>

        <div className="mt-2 text-sm text-gray-500">
          {selectedColors.length} selected from {colors.length}
        </div>
      </div>
    </div>
  );
};

export default ProductAttributesSelector;